import './Demo.css';

function Demo() {

  return (
    <div className='demo-page'>

      {/* <div className='demo-header'>
        <a style={{ color: '#0088ca' }} href="/overview" className="back-button">Back</a>
      </div> */}

      <div className="y-space-40"></div>

      <div className="demo-container">
        <h1>Demo</h1>
        <div style={{display: 'flex', flexDirection: 'column', justifyContent: 'center', alignItems: 'center'}}>
          
          <iframe className='demo-player'  src="https://www.youtube.com/embed/VW5TB9OeL9o?si=urFnPenrt8y9ZGet&amp;controls=1" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" allowfullscreen></iframe>

        <br />

        Real-time call to a Probate and Estate Planning Law Firm using Sayable.ai.
        </div>

        <div className="demo-footer">
          <p></p>
        </div>
      </div>
    </div>
  );
}

export default Demo;
